// Shared helpers for My Listings bulk Change Owner (desktop table + mobile cards).

// The per-row Change Owner action is not rendered for rejected listings, so they cannot be bulk-selected either.
export const isListingBulkSelectable = (listing) =>
  (listing?.disposition?.slug ?? listing?.platforms?.unified?.disposition?.slug) !== 'rejected';

// Same precedence as the single-listing Change Owner modal (bayut, dubizzle, unified), so owner ids match agency users.
export const getListingOwner = (listing) =>
  listing?.platforms?.bayut?.listingOwner ??
  listing?.platforms?.dubizzle?.listingOwner ??
  listing?.platforms?.unified?.listingOwner ??
  listing?.user;

export const getSelectedCountLabel = (t, count) =>
  count === 1 ? t('{{count}} listing selected', { count }) : t('{{count}} listings selected', { count });
